<script setup>
import { ref, inject } from "vue";
import { getCurrentLocale } from "@/helpers/apiHelper";

const snippets = inject("statamic_snippets");

const isOfficeView = ref(true);
const officeStaffData = ref([]);
const trainersStaffData = ref([]);

const props = defineProps({
    currentSite: {
        type: String,
        required: true,
    },
});

const correctSiteUrl = getCurrentLocale(props.currentSite);

fetch(`/api/collections/employee/entries?filter[site]=${correctSiteUrl}`).then((result) => {
    result.json().then((data) => {
        officeStaffData.value = data.data;
    });
});

fetch(`/api/collections/trainer/entries?filter[site]=${correctSiteUrl}`).then((result) => {
    result.json().then((data) => {
        trainersStaffData.value = data.data;
    });
});
</script>
<template>
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-10">
        <template v-if="isOfficeView">
            <div class="col-span-2 md:col-span-3 lg:col-span-5">
                <h2
                    class="font-heading uppercase text-lg md:text-xl lg:text-2xl xl:text-3xl text-center text-blue"
                    v-text="snippets.team_overview_snippets_office_section_title"
                ></h2>
            </div>
            <div v-for="(employee, employeeIndex) in officeStaffData" :key="employeeIndex" class="col-span-1">
                <div
                    class="block bg-white flex-shrink-0 h-full shadow-topanimation w-full"
                    itemscope
                    itemtype="https://schema.org/Person"
                >
                    <div class="w-full h-auto overflow-hidden aspect-square">
                        <img
                            v-if="employee.photo"
                            class="w-full h-full object-cover"
                            :src="employee.photo.small_w300_permalink"
                            :alt="employee.title"
                            itemprop="image"
                        />
                    </div>
                    <div class="py-1 text-center">
                        <h3
                            class="font-heading uppercase text-lg md:text-xl"
                            itemprop="name"
                            v-text="employee.title"
                        ></h3>
                        <span class="font-running-text text-sm md:text-base" v-text="employee.function"></span>
                    </div>
                </div>
            </div>
            <div
                class="bg-blue p-5 flex-shrink-0 h-full border border-gray-300 shadow-topanimation w-full flex flex-col justify-between items-center transition duration-300 ease-in-out group hover:cursor-pointer"
                @click="isOfficeView = !isOfficeView"
            >
                <h4
                    class="py-1 font-heading uppercase md:text-lg lg:text-xl xl:text-2xl text-white text-center mb-5 md:mb-0"
                    v-text="snippets.team_overview_snippets_meet_the_trainers_title"
                ></h4>
                <button
                    class="px-5 py-2 flex items-center border-b border-orange-600 bg-orange text-white flex-grow-0 space-x-3 font-bold w-max-w group-hover:border-teal-600 group-hover:bg-teal focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
                    v-text="snippets.team_overview_snippets_meet_the_trainers_button_text"
                ></button>
            </div>
        </template>
        <template v-else>
            <div class="col-span-2 md:col-span-3 lg:col-span-5">
                <h2
                    class="font-heading uppercase text-lg md:text-xl lg:text-2xl xl:text-3xl text-center text-blue"
                    v-text="snippets.team_overview_snippets_trainer_section_title"
                ></h2>
            </div>
            <div v-for="(trainer, trainerIndex) in trainersStaffData" :key="trainerIndex" class="col-span-1">
                <div
                    class="block bg-white flex-shrink-0 h-full shadow-topanimation w-full"
                    itemscope
                    itemtype="https://schema.org/Person"
                >
                    <div class="w-full h-auto overflow-hidden aspect-square">
                        <img
                            v-if="trainer.photo"
                            class="w-full h-full object-cover"
                            :src="trainer.photo.small_w300_permalink"
                            :alt="trainer.title"
                            itemprop="image"
                        />
                    </div>
                    <div class="py-1 text-center font-heading uppercase text-lg md:text-xl">
                        <h3 itemprop="name" v-text="trainer.title"></h3>
                    </div>
                </div>
            </div>
            <div
                class="bg-teal p-5 flex-shrink-0 h-full border border-gray-300 shadow-topanimation w-full flex flex-col justify-between items-center transition duration-300 ease-in-out group hover:cursor-pointer"
                @click="isOfficeView = !isOfficeView"
            >
                <h4
                    class="py-1 font-heading uppercase md:text-lg lg:text-xl xl:text-2xl text-white text-center mb-5 md:mb-0"
                    v-text="snippets.team_overview_snippets_meet_the_office_title"
                ></h4>
                <button
                    class="px-5 py-2 flex items-center border-b border-orange-600 bg-orange text-white flex-grow-0 space-x-3 font-bold w-max-w group-hover:border-blue-600 group-hover:bg-blue focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
                    v-text="snippets.team_overview_snippets_meet_the_office_button_text"
                ></button>
            </div>
        </template>
    </div>
</template>
